import { render, staticRenderFns } from "./PaperSelect.vue?vue&type=template&id=c8936a66&scoped=true&"
import script from "./PaperSelect.vue?vue&type=script&lang=js&"
export * from "./PaperSelect.vue?vue&type=script&lang=js&"
import style0 from "./PaperSelect.vue?vue&type=style&index=0&id=c8936a66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8936a66",
  null
  
)

export default component.exports